<script setup lang="ts">
interface Properties {
  alternativeText: string;
  height?: number | string;
  loading?: "eager" | "lazy";
  source: string;
  width?: number | string;
}

withDefaults(defineProps<Properties>(), {
  height: undefined,
  loading: "lazy",
  width: undefined,
});
</script>

<template>
  <img :alt="alternativeText" :height="height" :loading="loading" :src="source" :width="width" />
</template>
